import {
  UPDATEORADDWALLETOWNERBANKDETAILS_SUCCESS,
  UPDATEORADDWALLETOWNERBANKDETAILS_FAILED,
  RESET_UPDATEORADDWALLETOWNERBANKDETAILS,
  LOADING_UPDATEORADDWALLETOWNERBANKDETAILS,
  NETWORK_ERROR_UPDATEORADDWALLETOWNERBANKDETAILS,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateWalletDetails = () => {
  return { type: RESET_UPDATEORADDWALLETOWNERBANKDETAILS };
};

const updateWalletDetailsReq = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_UPDATEORADDWALLETOWNERBANKDETAILS });
  await partnerServices
    .post(
      "updateOrAddWalletOwnerBankDetails", userData, { headers: { AuthToken: authTokenIs } }
    )
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(updateWalletDetailssuccess(res.data));
          break;
        default:
          dispatch(updateWalletDetailsFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_UPDATEORADDWALLETOWNERBANKDETAILS,
        payload: err,
      });
    });
};
function updateWalletDetailssuccess(data) {
  return {
    type: UPDATEORADDWALLETOWNERBANKDETAILS_SUCCESS,
    payload: data,
  };
}
function updateWalletDetailsFailed(data) {
  return {
    type: UPDATEORADDWALLETOWNERBANKDETAILS_FAILED,
    payload: data,
  };
}

export { resetUpdateWalletDetails, updateWalletDetailsReq };
